import {
  MDBAlert,
  MDBBtn,
  MDBCheckbox,
  MDBDatatable,
  MDBIcon,
  MDBInput,
  MDBSpinner,
  MDBTextArea,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import PopupLoaderNew from "../../../views/popups/PopupLoaderNew";
import AddExterNum from "../../../views/popups/misc/AddExterNum";
import { useTranslation } from "react-i18next";
import { useFieldArray, useFormContext } from "react-hook-form";
import PopupLoader from "../../../views/popups/PopupLoader";
import ToggleEditWarning from "../hunt/ToggleEditWarning";
import {
  getMisc,
  updateLunaDetails,
} from "../../../apiclients/streamsapi_bridge";
import DeleteLunaExternalNumber from "../../../views/popups/Luna/DeleteLunaExternalNumber";
import EditExterNum from "../../../views/popups/misc/EditExterNum";
import { formattedNumber } from "../../../views/popups/phonenumbers/AddRemoveNumbers";
import { Tooltip } from "react-tooltip";
import TextareaAutosize from 'react-textarea-autosize';
import { customSearch } from "../../CustomSearchUtil/CustomSearch";

function LunaExternalNumber({
  externalNumbers,
  scheduleId,
  lunaid,
  setSuccessMessage,
  isActive,
  extTextValue,
  extError,
  setextError,
  onResetDone,
}) {
  const { t, i18n } = useTranslation();
  const [isLoading, setisLoading] = useState(false);
  const [AddExternalNumber, setAddExternalNumber] = useState(false);
  const [exdetails, setExDetails] = useState({});
  const [exUpdate, setExUpdate] = useState(false);
  const [exEdited, setExEdited] = useState(false);
  const [callerids, setCallerids] = useState([]);
  const [calleridFlag, setCalleridFlag] = useState(true);
  const [externError, setExternError] = useState([]);
  const addUserRef = useRef(null);
  const [isloading, setIsloading] = useState(false);
  const [externalDeleteError, setexternalDeleteError] = useState("");
  const [deleteFlag, setdeleteFlag] = useState(false);
  const [deleteExtid, setdeleteExtid] = useState({});

  const toggleShow15 = () => setAddExternalNumber(!AddExternalNumber);
  const [delExternalNumber, setDelExternalNumber] = useState(false);
  const deltoggleShow = () => setDelExternalNumber(!delExternalNumber);
  function handleClick() {
    addUserRef.current.click();
  }

  const [editEternalNum, seteditEternalNum] = useState(false);
  const edittoggle = () => seteditEternalNum(!editEternalNum);
  const [externalInfo, setExternalInfo] = useState({});

  const [selectAllRadio, setselectAllRadio] = useState("-1");
  const [updateFieldName, setupdateFieldName] = useState("");
  const [updateFieldValue, setupdateFieldValue] = useState("");
  const [toggleValue, settoggleValue] = useState(-1);
  const [columnName, setcolumnName] = useState("");
  const [editWarning, seteditWarning] = useState(false);
  const warningToggle = () => seteditWarning(!editWarning);
  const [internalError, setInternalError] = useState(false);
  const [externalNumberList, setexternalNumberList] = useState([]);
  const {
    setValue,
    watch,
    control,
    reset,
    clearErrors,
    formState: { errors },
    unregister,
    register,
  } = useFormContext();
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [initialValues, setInitialValues] = useState([]);
  const [extText, setextText] = useState({});
  const [focusedIndex, setFocusedIndex] = React.useState(null);
  const [searchValue, setSearchValue] = useState(""); // Add search value state
  const [filteredIndices, setFilteredIndices] = useState([]); // Track which indices to show
  const { fields } = useFieldArray({
    name: "ext_num.edit_perm",
    control,
  });

  useEffect(() => {
    setSearchValue(""); 
    if (fields && Array.isArray(fields) && fields.length > 0) {
      setFilteredIndices(fields.map((_, index) => index));
    } else {
      setFilteredIndices([]);
    }
  }, [fields.length]);

  useEffect(() => {
    if (externalNumbers && externalNumbers.length > 0) {
      setexternalNumberList(externalNumbers);
      setInitialValues(
        externalNumbers.map((item) => ({
          ph_id: item.ph_id,
          info: item.info,
          flag: item.flag,
        }))
      );
    }
  }, [externalNumbers]);

  useEffect(() => {
    if (externalNumberList) {
      // Update only the `edit_perm` field using setValue
      setValue("ext_num.edit_perm", externalNumberList, { shouldDirty: false });
      onResetDone?.();
    }
  }, [externalNumberList, setValue]);

  async function getCallerIds() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["callerid_list"] }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
    }
    setCallerids(tdata?.misc?.callerid_list ?? []);
  }

  useEffect(() => {
    if (isActive) {
      getCallerIds();
    }
  }, [isActive]);

  function handleAllChange(feildName, columnName, value) {
    clearErrors(`ext_num.is_perm_enabled`);
    setextError("");
    if (value !== "-1") {
      setupdateFieldName(feildName);
      setupdateFieldValue(value);
      seteditWarning(true);
      // setuniqueKeyValue(resetFieldid);
      settoggleValue(value);
      setcolumnName(columnName);
    }
  }

  const handleSearch = (value) => {
    setSearchValue(value); // <--- add this

    // Safety check for fields array
    if (!fields || fields.length === 0) {
      setFilteredIndices([]);
      return;
    }
    
    if (!value.trim()) {
      // Show all items when search is cleared
      setFilteredIndices(fields.map((_, index) => index));
      return;
    }
    
    // Use your existing customSearch method
    const filterResult = customSearch(fields, value, ["title", "phnumber","formatted_phnumber"]);
    
    // Find indices of filtered results in original fields array
    const matchingIndices = filterResult.map(filteredItem => 
      fields.findIndex(field => 
        field && ( // Add safety check for field existence
          field.id === filteredItem.id || 
          (field.title === filteredItem.title && field.phnumber === filteredItem.phnumber )
        )
      )
    ).filter(index => index !== -1);
    
    setFilteredIndices(matchingIndices);
  };

  function handleCloseWarning() {
    setselectAllRadio("-1");
    warningToggle();
  }

  function handleUpdateToggle() {
    fields.forEach((field, index) => {
      const initialFlag = initialValues[index]?.flag || 0;
      const hasChanged =
        updateFieldValue !== (initialFlag === 0 ? false : true);
      if (hasChanged) {
        setValue(
          `ext_num.edit_perm.${index}.${updateFieldName}`,
          updateFieldValue ? 1 : 0,
          {
            shouldDirty: hasChanged,
          }
        );
      } else {
        unregister(`ext_num.edit_perm.${index}.${updateFieldName}`);
      }
    });

    setselectAllRadio("-1");
    warningToggle();
  }

  function handleRemoveExternal(e, deletenumObj) {
    e.preventDefault();
    e.stopPropagation();
    console.log("delete json vlaue :::::: " + JSON.stringify(deletenumObj));
    setdeleteExtid(deletenumObj);
    deltoggleShow();
  }

  function enabletoggle(e, index) {
    // debugger;
    const initialFlag = initialValues[index]?.flag || 0;
    const newFlag = e.target.checked ? 1 : 0;
    const hasChanged = newFlag !== initialFlag;
    if (hasChanged) {
      setValue(`ext_num.edit_perm.${index}.flag`, e.target.checked ? 1 : 0, {
        shouldDirty: hasChanged,
      });
    } else {
      unregister(`ext_num.edit_perm.${index}.flag`);
    }
  }

  useEffect(() => {
    if (extTextValue && Object.entries(extTextValue).length > 0) {
      setextText(extTextValue);
    }
  }, [extTextValue]);

  useEffect(() => {
    // Cleanup function to clear timeout when component unmounts or input value changes
    return () => {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
    };
  }, [typingTimeout]);

  function handleInfoChange(index, id, value) {
    // setextText((prev) => ({ ...prev, [id]: value }));
    // if (typingTimeout) {
    //   clearTimeout(typingTimeout);
    // }
    // const newTimeout = setTimeout(() => {
    const initialValue =
      initialValues.find((item) => item.ph_id === id)?.info || "";
    const hasChanged = value !== initialValue;
    if (hasChanged) {
      setValue(`ext_num.edit_perm.${index}.info`, value, {
        shouldDirty: hasChanged,
      });
    } else {
      unregister(`ext_num.edit_perm.${index}.info`);
    }
    // clearErrors(`ext_num.is_perm_enabled`);
    // }, 1000);
    // setTypingTimeout(newTimeout);
  }

  let processdrows = [];
  // fields.map((ext_num, index) => {
    if (fields && fields.length > 0 && filteredIndices.length > 0) {
      filteredIndices.forEach((originalIndex) => {
    const ext_num = fields[originalIndex];

    if (!ext_num || typeof ext_num !== 'object') return;       

    const isFocused = focusedIndex === originalIndex;
    processdrows.push({
      ext_num_Info: ext_num,
      name: ext_num.title,
      number: (
        <>
          <div className="d-flex flex-column">
            <span>
              {formattedNumber(ext_num.phnumber)}
            </span>
            {ext_num.cid_pass && (
              <>
                <p
                  className="small"
                  title={`Caller ID Pass Through : ${ext_num.cid_pass}`}
                  style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                >
                  Caller ID Pass Through :{ext_num.cid_pass}
                </p>
              </>
            )}
            {ext_num.cid_pass_flag ? ext_num.cid_pass : ""}
          </div>
        </>
      ),
      actualNumber: ext_num.phnumber,
      formattedNumber: formattedNumber(ext_num.phnumber),
      information: (
        <>
          {watch(`ext_num.edit_perm.${originalIndex}.flag`)
            ??
            initialValues[originalIndex]?.flag === 1
            ? (
              <div className={`position-relative ${isFocused ? "" : "no-scrollbar-textarea"}`}>
                <TextareaAutosize
                  minRows={isFocused ? 9 : 4}
                  maxRows={isFocused ? 9 : 4}
                  className="w-100"
                  maxLength={500}
                  // value={extText[ext_num.ph_id] || ""}
                  {...register(`ext_num.edit_perm.${originalIndex}.info`)}
                  onFocus={() => setFocusedIndex(originalIndex)}
                  onBlur={(e) => {
                    const relatedTarget = e.relatedTarget;
                    if (relatedTarget && relatedTarget.closest('.phoneselect')) {
                      return;
                    }
                    setFocusedIndex(null);
                  }}
                  onChange={(e) => {
                    // clearErrors(`aa.is_perm_enabled`);
                    setextError("");
                    handleInfoChange(originalIndex, ext_num.ph_id, e.target.value);
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                  }}
                />
                <div
                  className="  text-muted text-end lh-normal pe-1 pb-1 "
                  style={{
                    fontSize: "10.5px",
                    pointerEvents: "none"
                  }}
                >
                  {watch(`ext_num.edit_perm.${originalIndex}.info`)?.length || 0}/500
                </div>
              </div>
            ) : (
              ""
            )}
        </>
      ),
      active: (
        <>
          <div className="d-flex align-items-center justify-content-center">
            <div
              className="phoneselect"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <label className="switch">
                <input
                  className="form-control"
                  type="checkbox"
                  checked={
                    watch(`ext_num.edit_perm.${originalIndex}.flag`) ??
                    initialValues[originalIndex]?.flag === 1
                  }
                  onChange={(e) => {
                    e.preventDefault();
                    setextError("");
                    clearErrors(`ext_num.is_perm_enabled`);
                    enabletoggle(e, originalIndex);
                  }}
                  name="DefualtLocation"
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        </>
      ),
      remove: (
        <>
          <div className="d-flex align-items-center ms-3">
            <div
              className="custom-hover-bg p-1 cursor-pointer deleteToolTip"
              onClick={(e) => handleRemoveExternal(e, ext_num)}
            >
              <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
            </div>
          </div>
        </>
      ),
    });
  });
    }
  const ExternalNumber = {
    columns: [
      {
        label: "Name",
        field: "name",
      },
      {
        label: "Number",
        field: "number",
      },
      {
        label: (
          <>
            <div className="fw-bold">Information <MDBIcon icon="info-circle" className="ms-3 enternal_num" /></div>
          </>
        ),
        field: "information",
        sort: false,
      },
      {
        label: (
          <>
            <div className="d-flex align-items-center flex-column justify-content-center">
              <p className="fw-bold">Active</p>

              {/* <div className="three-checkbox round2 mx-0">
                <input
                  type="radio"
                  name="UsersExternalNumbers"
                  checked={selectAllRadio === false}
                  onChange={(e) => {
                    if (e) {
                      setselectAllRadio(false);
                      handleAllChange("flag", "Active", false);
                    }
                  }}
                />
                <input
                  type="radio"
                  name="UsersExternalNumbers"
                  checked={selectAllRadio === "-1"}
                  onChange={(e) => {
                    if (e) {
                      setselectAllRadio("-1");
                      handleAllChange("flag", "Active", "-1");
                    }
                  }}
                />
                <input
                  type="radio"
                  name="UsersExternalNumbers"
                  checked={selectAllRadio === true}
                  onChange={(e) => {
                    if (e) {
                      setselectAllRadio(true);
                      handleAllChange("flag", "Active", true);
                    }
                  }}
                />
                <span className="slider"></span>
              </div> */}
            </div>
          </>
        ),
        field: "active",
        sort: false,
      },
      {
        label: "Remove",
        field: "remove",
        sort: false,
      },
    ],
    rows: processdrows,
  };

  useEffect(() => {
    if (exdetails && exUpdate) {
      sendApiRequest(exdetails, "add_ext_num");
      setExUpdate(false);
    }
  }, [exUpdate, exdetails]);

  useEffect(() => {
    if (exdetails && exEdited) {
      let updatedExt = {
        ...exdetails,
        title: exdetails.name,
        phnumber: exdetails.uniqueid,
      };
      sendApiRequest(updatedExt, "edit_ext_num");
      setExEdited(false);
    }
  }, [exEdited, exdetails]);

  async function sendApiRequest(exdetails, keyName) {
    try {
      const formData = new FormData();
      let luna_permissions = {
        ext_num: {
          [keyName]: exdetails,
        },
      };
      formData.append("reqid", 150);
      formData.append(
        "siteid",
        JSON.parse(sessionStorage.getItem("admin_session")).siteid
      );
      formData.append("lunaid", lunaid);
      const scheduleType =
        scheduleId === 1
          ? "alltime"
          : scheduleId === 2
            ? "open"
            : scheduleId === 3
              ? "closed"
              : "holiday";
      formData.append("schedule_type", scheduleType);
      formData.append("luna_permissions", JSON.stringify(luna_permissions));
      setisLoading(true);
      for (let [key, value] of formData.entries()) {
        console.log(`form data fields :::::: ${key}: ${value}`);
      }
      let saverep = await updateLunaDetails(formData);
      setisLoading(false);

      let saverepeMsg = await saverep.json();
      console.log("response ::::::::::: " + JSON.stringify(saverepeMsg));
      if (saverepeMsg.status && saverepeMsg.status == "success") {
        if (keyName === "add_ext_num") {
          const newRecord = {
            ...exdetails,
            title: exdetails.name,
            phnumber: exdetails.uniqueid,
            info: "",
            flag: 0,
            ph_id: saverepeMsg.externalNumId,
          };
          const updatedNumber = [...externalNumberList, newRecord];
          setexternalNumberList(updatedNumber);
          setAddExternalNumber(false);
        } else {
          let updatedList = externalNumberList.map((item) =>
            (item.ph_id === exdetails.ph_id || item.ph_id === exdetails.val) ? { ...item, ...Object.fromEntries(Object.entries(exdetails).filter(([key, value]) => key in item && value != undefined)) } : item
          );
          setexternalNumberList(updatedList);
          seteditEternalNum(false);
        }
        setSuccessMessage(saverepeMsg.message);
      } else {
        if (saverepeMsg.message?.errors) {
          setExternError(saverepeMsg.message?.errors);
        }
      }
      setExDetails({});
    } catch (error) {
      console.log("error in add external number :::: " + error);
    }
  }

  // useEffect(() => {
  //         // Cleanup function to clear timeout when component unmounts or input value changes
  //         return () => {
  //             if (typingTimeout) {
  //                 clearTimeout(typingTimeout);
  //             }
  //         };
  //     }, [typingTimeout]);

  //     function handleInfoChange(value, index) {
  //         try {
  //             if (typingTimeout) {
  //                 clearTimeout(typingTimeout);
  //             }
  //             const newTimeout = setTimeout(() => {
  //               setValue(`ext_num.edit_perm.${index}.info`, value, {
  //                 shouldDirty: true,
  //               })
  //             }, 500);
  //             // Update the typingTimeout state with the new timeout
  //             setTypingTimeout(newTimeout);

  //         } catch (error) {
  //             console.log(`Error in handleInfoChange :::: ${error}`);

  //         }
  //     }
  useEffect(() => {
    if (deleteExtid && deleteFlag) {
      sendDeleteApiRequest();
      setExUpdate(false);
    }
  }, [deleteExtid, deleteFlag]);

  async function sendDeleteApiRequest() {
    const formData = new FormData();
    let luna_permissions = {
      ext_num: {
        delete_ext_num: {
          ph_id: deleteExtid.ph_id,
          phnum: deleteExtid.phnumber,
        },
      },
    };
    formData.append("reqid", 150);
    formData.append(
      "siteid",
      JSON.parse(sessionStorage.getItem("admin_session")).siteid
    );
    formData.append("lunaid", lunaid);
    const scheduleType =
      scheduleId === 1
        ? "alltime"
        : scheduleId === 2
          ? "open"
          : scheduleId === 3
            ? "closed"
            : "holiday";
    formData.append("schedule_type", scheduleType);
    formData.append("luna_permissions", JSON.stringify(luna_permissions));

    setisLoading(true);
    for (let [key, value] of formData.entries()) {
      console.log(`form data fields :::::: ${key}: ${value}`);
    }
    let saverep = await updateLunaDetails(formData);
    setisLoading(false);

    let saverepeMsg = await saverep.json();
    console.log("response ::::::::::: " + JSON.stringify(saverepeMsg));
    // debugger;
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      const updatedList = externalNumberList.filter(
        (ext) => ext.ph_id !== deleteExtid.ph_id
      );
      setexternalNumberList(updatedList);
      setDelExternalNumber(false);
      setSuccessMessage(saverepeMsg.message);
    } else {
      setInternalError(true);
    }
    setdeleteFlag(false);
    setdeleteExtid({});
  }

  function handleRowClick(tdata) {
    console.log(JSON.stringify(tdata.ext_num_Info) + " -> Row Info");
    setExternalInfo(tdata.ext_num_Info);
    edittoggle();
  }
  return (
    <>
      <div className="section-content">
        <div className="d-flex align-items-center justify-content-between mb-3 pe-4">
          <div className="general-settings m-0">External Number</div>
          <div className="phoneselect">
            <label className="switch">
              <input
                className="form-control"
                type="checkbox"
                name="DefualtLocation"
                value={watch("ext_num.is_perm_enabled")}
                checked={watch("ext_num.is_perm_enabled")}
                onChange={(e) => {
                  setextError("");
                  clearErrors(`ext_num.is_perm_enabled`);
                  setValue(`ext_num.is_perm_enabled`, e.target.checked, {
                    shouldDirty: true,
                  });
                }}
              />
              <span className="slider round"></span>
            </label>
            {errors?.ext_num?.is_perm_enabled && (
              <p className="text-danger">
                {errors?.ext_num?.is_perm_enabled?.message}
              </p>
            )}
          </div>
        </div>
        {watch("ext_num.is_perm_enabled") && (
          <>
            <div className="actionbar">
              <MDBBtn onClick={toggleShow15}>
                <MDBIcon fas icon="plus" className="me-2" />
                Add External Numbers
              </MDBBtn>
            </div>
            <div className='mb-2 mt-0 position-relative w-auto'>
              <MDBInput
                label="Search"
                value={searchValue}
                onChange={(e) => handleSearch(e.target.value)}
              />
              <MDBIcon fas icon="search" className='MDBDatatable-Search' />
            </div>
            <div className="LunaExternalNumber">
              {extError && <p className="text-danger">{extError}</p>}
              <MDBDatatable
                className="actioncolumn top"
                key={searchValue}
                // search
                // pagination={false}
                fixedHeader
                hover
                data={ExternalNumber}
                onRowClick={(tdata) => handleRowClick(tdata)}
              />
            </div>
          </>
        )}
      </div>

      {AddExternalNumber && (
        <PopupLoaderNew
          size="md"
          title={t("addExternal")}
          content={
            <AddExterNum
              setExDetails={setExDetails}
              setExUpdate={setExUpdate}
              onClose={toggleShow15}
              externError={externError}
              setExternError={setExternError}
              callerids={callerids}
              calleridFlag={calleridFlag}
              ref={addUserRef}
              setIsloading={setisLoading}
            />
          }
          onShow={setAddExternalNumber}
          onClose={toggleShow15}
          onSave={handleClick}
          isloading={isLoading}
          flag={1}
        />
      )}

      {editEternalNum && (
        <PopupLoaderNew
          size="sm"
          className="modal-sm"
          title={t("Edit External Number")}
          content={
            <EditExterNum
              setExDetails={setExDetails}
              setExEdited={setExEdited}
              onClose={edittoggle}
              externError={externError}
              setExternError={setExternError}
              callerids={callerids}
              calleridFlag={calleridFlag}
              externalInfo={externalInfo}
              ref={addUserRef}
              setIsloading={setisLoading}
            />
          }
          onShow={seteditEternalNum}
          onClose={edittoggle}
          onSave={handleClick}
          isloading={isLoading}
          flag={2}
        />
      )}

      {delExternalNumber && (
        <PopupLoaderNew
          size="md"
          title={t("Remove External Number")}
          content={
            <DeleteLunaExternalNumber
              setdeleteFlag={setdeleteFlag}
              onClose={deltoggleShow}
              ref={addUserRef}
              setIsloading={setisLoading}
            />
          }
          onShow={setDelExternalNumber}
          onClose={deltoggleShow}
          onSave={handleClick}
          isloading={isLoading}
          flag={4}
        />
      )}
      {editWarning && (
        <PopupLoader
          size="md"
          title="Warning"
          content={
            <ToggleEditWarning
              handleUpdateToggle={handleUpdateToggle}
              handleCloseWarning={handleCloseWarning}
              toggleValue={null}
              columnName={columnName}
              isLuna={true}
            />
          }
          onShow={seteditWarning}
          onClose={handleCloseWarning}
        />
      )}
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
      {internalError && (
        <MDBAlert
          open
          className="alert-center"
          color="danger"
          autohide
          position="bottom-right"
          delay={5000}
          onClose={() => setInternalError(false)}
        >
          Internal Server Error
        </MDBAlert>
      )}

      <Tooltip anchorSelect=".enternal_num" place="top" className="exampleTooltipLight">
        Tells Luna what each active External Number is Used for.
      </Tooltip>
    </>
  );
}
export default React.memo(LunaExternalNumber);
